/* eslint-disable keyword-spacing */
import axios from 'axios';
import EventBus from '@/utils/eventBus';
import i18n from '@/main';

// import { setupCache } from 'axios-cache-adapter';

import notification from 'element-ui/lib/notification';

// import router from '@/router.js';

import store from '@/store.js';

const BASE_URL = process.env.VUE_APP_HTTP_PATH;

axios.defaults.timeout = 3600000;

let stackLoading = 0;

const HttpStatus = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500
};

const showLoading = options => {
    options.mostrarLoading = true;
    EventBus.$emit('emit-componente-carregando', options);
    stackLoading++;
};

const hideLoading = options => {
    stackLoading--;

    if (stackLoading <= 0) {
        stackLoading = 0;
        options.mostrarLoading = false;
        EventBus.$emit('emit-componente-carregando', options);
    }
};

const defaultOptions = {
    baseURL: BASE_URL,
    responseType: 'json'
};

const axiosInstance = axios.create(defaultOptions);

export const cancelAllRequests = () => {
    axiosInstance.interceptors.request.use(
        config => {
            config.cancelToken = new axios.CancelToken(cancel => {
                EventBus.$on('cancel-all-requests', cancel);
            });

            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
};

export default class Http {
    static baseURL() {
        return BASE_URL;
    }

    static _getOptionValue(options, prop, defaultValue) {
        if (!options || !options.hasOwnProperty(prop)) {
            return defaultValue;
        } else {
            return options[prop];
        }
    }

    static _handleRequestPromisse(promisse, options) {
        promisse
            .then(response => {
                if (options.lockScreen) {
                    hideLoading(options);
                }

                if (options.success) {
                    options.success(response.data);
                }
            })
            .catch(error => {
                if (options.lockScreen) {
                    hideLoading(options);
                }

                if (error.request.status === HttpStatus.UNAUTHORIZED) {
                    notification.error({
                        message: 'Dados de login inválidos'
                    });
                }

                if (error.request.status === HttpStatus.FORBIDDEN) {
                    /**
                     * Redirecionamento para a página principal após a notificação sumir.
                     */

                    notification.error({
                        message: error.response.data.message,
                        onClose: () => {
                            store.dispatch('setUsuarioLogado', null);
                        }
                    });
                }

                if (
                    options.notify &&
                    options.notify.status &&
                    options.notify.status.length > 0
                ) {
                    if (options.notify.status.includes(error.request.status)) {
                        notification.error({
                            message: error.request.response.message
                        });
                    }
                }
            });
    }

    static async setHeader() {
        let jwt = sessionStorage.getItem('jwtToken');

        axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;
        axios.defaults.headers.post['Content-Type'] =
            'application/x-www-form-urlencoded';
        axios.defaults.headers[
            'Accept-Language'
        ] = `${i18n.locale},${i18n.fallbackLocale};q=0.9`;
    }

    static async _setDefaultOptions(options) {
        options = options || {};
        options.fullUrl = options.url;
        options.lockScreen = Http._getOptionValue(options, 'lockScreen', true);
        options.lockMessage =
            options.lockMessage || i18n.t('mensagens.sistema.carregando');

        await Http.setHeader();

        return options;
    }

    static async get(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const responseType = options.responseType || 'json';
        const promisse = axiosInstance.get(options.fullUrl, {
            params: options.data || {},
            responseType
        });

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async post(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        options.data = {
            ...options.data
        };

        var config = {
            ...options.config
        };

        if (options.responseType) {
            config = {
                ...options.config,
                responseType: options.responseType
            };
        }

        var promisse = axiosInstance.post(
            options.fullUrl,
            options.data,
            config
        );

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async delete(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = options.data
            ? axiosInstance.delete(options.fullUrl, {
                  params: options.data
              })
            : axiosInstance.delete(options.fullUrl);
        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async put(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = axiosInstance.put(options.fullUrl, options.data);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async patch(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        var promisse = axiosInstance.patch(options.fullUrl, options.data);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async putFormData(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstance = axios.create({
            baseURL: BASE_URL,
            responseType: 'multipart/form-data'
        });

        let formData = new FormData();
        formData.append(options.data.nome, options.data.content);

        var promisse = axiosInstance.put(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async postFormData(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstanceNew = axios.create({
            baseURL: BASE_URL,
            // responseType: 'multipart/form-data',
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        const formData = new FormData();
        const arquivosManter = [];

        options.data.arquivosTerritorio.forEach(item => {
            const filesCategory = item.arquivoProdutor
                ? 'filesProdutor'
                : 'filesEmpresa';
            if (!item.urlDownload) {
                formData.append(filesCategory, item.arquivo.file);
            } else {
                arquivosManter.push(item.id);
            }
        });

        options.data.manterArquivos = arquivosManter;

        formData.append(
            'territorioInputPY',
            new Blob([JSON.stringify(options.data)], {
                type: 'application/json'
            })
        );

        const promisse = axiosInstanceNew.post(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async postFormDataAR(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstanceNew = axios.create({
            baseURL: BASE_URL,
            // responseType: 'multipart/form-data',
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        const formData = new FormData();

        options.data.arquivosTerritorio.forEach(item => {
            formData.append('files', item.file);
        });

        formData.append(
            'territorioInputAR',
            new Blob([JSON.stringify(options.data)], {
                type: 'application/json'
            })
        );

        const promisse = axiosInstanceNew.post(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }

    static async postFormDataAr(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstanceNew = axios.create({
            baseURL: BASE_URL,
            // responseType: 'multipart/form-data',
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        const formData = new FormData();

        options.data.arquivosTerritorio.forEach(item => {
            formData.append('files', item.file);
        });

        formData.append(
            'territorioInputAR',
            new Blob([JSON.stringify(options.data)], {
                type: 'application/json'
            })
        );

        const promisse = axiosInstanceNew.post(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }
    static async putFormDataAr(options) {
        options = await Http._setDefaultOptions(options);

        if (options.lockScreen) {
            showLoading(options);
        }

        const axiosInstanceNew = axios.create({
            baseURL: BASE_URL,
            // responseType: 'multipart/form-data',
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        const formData = new FormData();

        options.data.arquivosTerritorio.forEach(item => {
            formData.append('files', item.file);
        });

        formData.append(
            'territorioInputAR',
            new Blob([JSON.stringify(options.data)], {
                type: 'application/json'
            })
        );

        const promisse = axiosInstanceNew.put(options.fullUrl, formData);

        Http._handleRequestPromisse(promisse, options);

        return promisse;
    }
}
